import { cryptoSingle } from './crypto'
import { CUSTOM_LOG_APP_ID } from '../enum/const'
import { ERROR_CODE_MAP } from '../enum/codeMap'

let sign = undefined
let deviceId = undefined
let appId = undefined
const secret = 'e03b0da71d31f4c9e55b6f547f782097'
const customLogApi = process.env.VUE_APP_CUSTOM_LOG_API
const env = process.env.NODE_ENV === 'master' ? 'prod' : process.env.NODE_ENV

export const customLog = async (code, request, response) => {
  const sdkParams = JSON.parse(window.localStorage.getItem('sdkParams') || '{}')
  const properties = sdkParams.logData.properties

  // 初始化数据
  if (!sign) {
    deviceId = properties.pc_device_id || properties.device_id || 'null'
    sign = cryptoSingle(secret, deviceId)
    appId = CUSTOM_LOG_APP_ID[sdkParams.gid]
  }

  const content = ERROR_CODE_MAP[code] || ERROR_CODE_MAP[`KGSDK_${code}`] || '未定义'
  const appVersion = JSON.stringify(request || {})
  const osVersion = JSON.stringify(response || {})
  if (code === 500000 || code === 500001) {
    code = `${code}_${request.port || '-'}`
  }

  const headers = {
    'Content-Type': 'application/json',
    'X-Content-Secret': sign,
    'appId': appId,
    'env': env,
    'platform': 'pc',
    'event': 'pc_login',
    'deviceId': deviceId,
    'content': encodeURIComponent(content),
    'clickCode': code.toString(),
    'appVersion': encodeURIComponent(appVersion),
    'osVersion': encodeURIComponent(osVersion)
  }

  fetch(customLogApi, {
    method: 'post',
    body: '',
    credentials: 'include',
    mode: 'cors',
    headers: new Headers(headers)
  }).then(response => response.json()).catch(() => {})
}

if (process.env.NODE_ENV !== 'master') {
  window.postAllLog = () => {
    Object.keys(ERROR_CODE_MAP).forEach((key, index) => {
      setTimeout(() => {
        customLog(key, { action: 'action' }, { code: key, msg: 'msg' })
      }, index * 20);
    })
  }
}
